/** Shared structured quota notices for Axios, fetch and asynchronous jobs. */
import { shallowRef } from 'vue'
export const aiQuotaNotice = shallowRef<{ nextResetAt: string | null } | null>(null)
function record(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' ? value as Record<string, unknown> : null
}
export function findQuotaExhaustion(value: unknown, depth = 0): { nextResetAt: string | null } | null {
  const source = record(value)
  if (!source || depth > 5) return null
  if (source.code === 'AI_QUOTA_EXHAUSTED' || source.appCode === 'AI_QUOTA_EXHAUSTED') {
    const summary = record(source.quotaSummary) || record(record(source.data)?.quotaSummary)
    const date = summary?.nextResetAt
    return { nextResetAt: typeof date === 'string' && Number.isFinite(Date.parse(date)) ? date : null }
  }
  for (const key of ['response', 'data', 'error']) {
    const found = findQuotaExhaustion(source[key], depth + 1)
    if (found) return found
  }
  return null
}
export function notifyAiQuotaExhaustion(value: unknown): boolean {
  const notice = findQuotaExhaustion(value)
  if (!notice) return false
  aiQuotaNotice.value = notice
  return true
}
